export default {
  SocialNetworks: {
    Facebook: 'https://fb.me/alegraweb',
    Twitter: 'https://twitter.com/AlegraWeb',
    Linkedin: 'https://www.linkedin.com/company/alegra/',
    Youtube: 'https://www.youtube.com/user/AlegraWeb',
    Instagram: 'https://www.instagram.com/alegraweb',
    Tiktok: 'https://www.tiktok.com/@alegraweb',
  },
  /**
   * NMS
   */

  form: {
    name: 'Nombre',
    email: 'Correo electrónico',
    consultation_type: 'Tipo de consulta',
    consultation_type_placeholder: 'Selecciona el tipo de consulta',
    consultation_type_error: 'Selecciona un tipo de consulta para avanzar',
    consultation_details: 'Detalles de tu consulta',
  },

  alegraConnect: {
    title: '¡Migra fácil con Alegra Connect!',
    description:
      'Te ayudamos a importar tus clientes, inventarios y saldos iniciales desde tu software anterior, sin complicaciones y sin perder datos ni tiempo.',
    descriptionInline: 'Te ayudamos a transferir tu información de forma sencilla y segura.',
  },

  empty: {
    title: '¡Ups! No encontramos lo que buscas',
    description:
      'No se encontraron resultados para <strong>"{{search}}"</strong>. Intenta con otra búsqueda.',
  },
  survey: {
    nms: {
      title: 'Califica tu experiencia',
      subtitle:
        'Nos encantaría saber qué piensas. Evalúa que tan fácil fue para ti usar nuestro soporte.',
    },
  },
  advices: {
    privacy_policy: {
      title: 'Aviso de privacidad',
      description:
        'Este mensaje puede contener información confidencial o datos de carácter personal. Si no es el destinatario indicado o el responsable de su entrega, no revele, copie, distribuya o use este mensaje. Por favor comunique su recepción y elimínelo. ALEGRA declina cualquier responsabilidad por las alteraciones que pudieran hacerse del mensaje una vez enviado. Informamos de que ALEGRA SOLUCIONES, S.L. (“ALEGRA”) tratará los datos personales de este mensaje y los que formen parte de su cadena, como Responsable, con la finalidad de mantener la comunicación electrónica. No serán comunicados a ninguna otra persona o entidad, salvo que una obligación legal, judicial o administrativa así lo exija. Podrá ejercer sus derechos enviando correo electrónico a soporte@usuarios.alegra.com, o dirigiendo una carta a Avenida Sabino Arana, 8, Piso 2, 48013, Bilbao, Bizkaia, incluyendo como referencia "Ejercicio de Derechos". Más información en: Alegra España.',
    },
  },
  events: {
    pos: {
      advice: {
        title: 'Todo lo que debes saber sobre el POS electrónico 📢',
        description:
          'Durante <strong>junio y julio</strong> todos los <strong>martes de 10 a 11 hs</strong> COL, desde el 19/06',
      },
      today: {
        title: 'POS Electrónico: ¡Todo lo que necesitas saber! 🧑‍💻',
        description:
          'Aprende todo sobre el nuevo sistema de facturación que reemplaza el POS tradicional. Capacitaciones gratuitas <strong>todos los martes</strong> de junio y julio de <strong>10:00 a 11:00 am.</strong> ¡Únete ahora!',
      },
      yesterday: {
        title: 'POS Electrónico: ¡Todo lo que necesitas saber! 🧑‍💻',
        description:
          'Mañana aprenderás todo sobre el nuevo sistema de facturación que reemplaza el POS tradicional. Capacitaciones gratuitas <strong>todos los martes</strong> de junio y julio de <strong>10:00 a 11:00 am.</strong> ',
      },
    },
  },
  tags: {
    identification: 'Identificación: {{id}}',
    createIdentification: 'Configurar Identificación',
  },
  tooltips: {
    identification:
      'Tu identificación facilitará el reconocimiento de tu cuenta cuando llames a soporte.',
    createIdentification:
      'Tu identificación facilitará el reconocimiento de tu cuenta cuando llames a soporte.',
  },
  buttons: {
    file: 'Seleccionar archivo',
  },

  plans: {
    free: 'GRATIS',
    demo: 'DEMO',
    readonly: 'CONSULTA',
    internal: 'TÉCNICO',
    emprendedor: 'EMPRENDEDOR',
    pyme: 'PYME',
    pro: 'PRO',
    plus: 'PLUS',
    enterprise: 'PREMIUM',
    corporativo: 'PREMIUM',
    contador: 'CONTADOR',
    contador_sales: 'CONTADOR',
  },
  new_support_model: {
    wizard_steps: {
      step1: 'Descripción de tu inquietud',
      step2: 'Ayudas relacionadas',
      step3: 'Opciones de contacto',
    },
    described_inquery: {
      title: 'Hola, {{name}}, ¿cómo podemos ayudarte?',
      title_without_name: 'Hola, ¿cómo podemos ayudarte?',
      subtitle: 'Describe tu inquietud de forma general y te ayudaré a resolverla.',
      cta_btn: 'Continuar',
      notification_chat:
        '<strong>¡Tienes un chat abierto!</strong> Continúa tu conversación con soporte.',
    },
    relationated_helps: {
      title: 'Ayudas relacionadas',
      subtitle:
        'Algunas personas con una inquietud similar encontraron solución en uno de los siguientes artículos:',
      tabs_label: {
        all: 'Todos',
        article: 'Artículos',
        video: 'Videos',
        community: 'Foro comunitario',
      },
      support_card: {
        title: '¿Sigues sin resolver tu inquietud?',
        description: 'Explora tus opciones de soporte y ponte en contacto con nuestro equipo.',
        cta_btn: 'Ver opciones de soporte',
      },
    },
    contact_options: {
      title: 'Opciones de contacto',
      subtitle: 'Estas son las opciones de soporte disponibles para tu plan',
      subtitle_acc: 'Estas son las opciones de soporte disponibles para ti',
      support_options: {
        chat: {
          title: 'Habla con un agente por chat',
          description_sales:
            'Disponible de lunes a viernes de 8:00am a 12:00pm y de 2:00pm a 5:30pm Colombia',
          // description: 'Disponible de lunes a viernes de 9am a 12:30pm y de 2pm a 6:30pm',
          description: 'Disponible de lunes a viernes de 9am a 1:00pm y de 2:30pm a 6:30pm',
        },
        try_chat: {
          title: 'Habla con un agente por chat',
          description_sales:
            'Disponible de lunes a viernes de 8:00am a 12:00pm y de 2:00pm a 5:30pm Colombia',
          description:
            'Disponible de lunes a viernes de 9am a 1:00pm y de 2:30pm a 6:30pm <span style="color: #4F46E5;">¡Prueba gratis durante 15 días!</span>',
        },
        group_training: {
          title: 'Agenda una capacitación grupal',
          description: 'Únete a una sesión grupal y amplía tus conocimientos en comunidad.',
        },
        individual_advice: {
          title: 'Agenda una asesoría individual',
          description:
            'Selecciona el horario que mejor se ajuste a tus necesidades y disponibilidad.',
        },
        send_email: {
          title: 'Envía un correo',
          description:
            'Nuestra bandeja de entrada está <strong>disponible las 24 horas</strong> para resolver tus dudas.',
          step1: {
            subtitle:
              'Déjanos tu duda o consulta por aquí, y pronto un agente te ayudará a resolver tu caso.',
            file: {
              label:
                '¿Tienes capturas, documentos o imágenes? Cárgalas aquí, esto nos ayudará a identificar tu problema.',
              hint: 'Solo archivos JPG or PNG menores a 500mb',
            },
          },
          message_final: {
            title: '¡Correo enviado!',
            message: 'Nos pondremos en contacto muy pronto.',
            advice: 'Si no encuentras el correo, busca en la carpeta de Promociones o Spam.',
          },
        },
        whatsapp: {
          title: 'Escríbenos por WhatsApp',
          // description: 'Obtén asistencia personalizada a través de WhatsApp.',
          description:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          message_final: {
            title: 'Escríbenos por WhatsApp',
            message: 'Escanea el código QR para contactarnos usando la app en tu móvil.',
            button: 'Escribir desde WhatsApp Web ',
          },
        },
        call_agent: {
          title: 'Llama a un agente de soporte',
          description: 'Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales: 'Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          message_final: {
            title: 'Llama al {{phone}} para hablar con un agente de soporte',
            message: 'Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
            identificationAdvice:
              'Tu identificación facilitará el reconocimiento de tu cuenta durante llamadas de soporte.',
          },
          message_final_c2c: {
            title: 'Llama gratis a nuestros agentes',
            message:
              'Al iniciar, te llevaremos al servicio de llamadas para conectarte con un agente de soporte',
            button: 'Iniciar llamada',
          },
        },
        comunity_forum: {
          title: 'Consulta en el foro comunitario',
          description: 'Haz preguntas y obtén respuestas de la comunidad de usuarios de Alegra.',
        },
      },
      banner_upsell: {
        title: 'Accede a más opciones de soporte',
        description:
          'Mejora tu plan y ten acceso a más canales de soporte para recibir ayuda especializada cuando la necesites',
        ctas_btn: {
          upgrade: 'Actualizar plan',
          contact: 'Hablar con ventas',
          contact_support: 'Hablar con soporte',
        },
        modals: {
          contact: {
            title: 'Llama a un agente de Alegra',
            message_final: {
              title: 'Llama al {{phone}} y contacta a {{agent}}',
              message:
                'Disponible de lunes a viernes de 8:00 a.m. a 12:00 m. y de 2:00 p.m. a 5:30 p.m.',
            },
          },
        },
      },
    },
  },
}
